
import React from "react";

const Charts = ({ dqKPIScores = [] }) => {
  const categories = dqKPIScores.map((item) => item.name ?? "");
  const scores = dqKPIScores.map((item) => item.score ?? 0);

  // Dynamic color logic
  const getColor = (value) => {
  if (value >= 95) return "#009F52"; // ≥95% → Yellow#FFC100
  if (value >= 90) return "#FFC100"; // 90–94% → Green#009F52
  return "#FB0301";                  // <90% → Red
};
   const items = [
    { color: "bg-green-300", label: "<=90%" },
    { color: "bg-blue-600", label: "<=90%" },
    { color: "bg-purple-300", label: ">=90%  <=95%" },
  ];

  return (
    <>
    
    <div className="bg-white rounded-2xl pt-[6px] pb-[4px] pl-[4px]  border border-[#818181]" >
      {/* Header */}
      <div className="flex items-center border-b border-b-[#818181] pb-3 mb-4">
        <div className="w-[35px] h-[35px] rounded-[5px] bg-[#E8E8EB] ml-2 mr-3 mt-1" />
        <h2 className="text-lg font-semibold text-gray-700">DQ KPI Score</h2>
      </div>

      {/* KPI progress bars */}
      <div className="space-y-4 p-[8px]">
        {scores.length === 0 && (
          <div className="text-sm text-gray-500">No KPI data available.</div>
        )}

        {scores.map((val, idx) => {
          const color = getColor(val);
          const label = categories[idx] ?? `KPI ${idx + 1}`;

          return (
            <div key={idx} className="flex items-center gap-1">
              {/* Progress bar */}
              <div className="flex-1">
                <div className="relative h-6 bg-gray-200 rounded overflow-hidden">
                  <div
                    className="h-6"
                    style={{
                      width: `${val}%`,
                      background: color,
                      transition: "width 700ms ease",
                    }}
                  />
                </div>
              </div>

              {/* Percentage */}
              <div className="w-20 text-right text-lg font-bold text-gray-800">
                {val}%
              </div>

              {/* KPI name */}
              <div className="w-40 text-sm font-medium text-gray-700">
                {label}
              </div>
            </div>
          );
        })}
       </div>
    </div>
    </>
  );
};

export default Charts;


